import React from 'react';

const NewsPagination = ({ currentPage, onPageChange, hasMore = true }) => {
  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (hasMore) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div className="flex items-center justify-center space-x-4 mt-10 mb-6">
      <button
        onClick={handlePrevious}
        disabled={currentPage <= 1}
        className={`flex items-center px-5 py-2.5 rounded-lg font-medium transition-all ${
          currentPage <= 1
            ? 'bg-gray-100 text-gray-400 cursor-not-allowed dark:bg-gray-800 dark:text-gray-600'
            : 'bg-white text-gray-700 hover:bg-gray-50 shadow-md hover:shadow-lg dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700'
        }`}
      >
        <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
        Önceki
      </button>

      <div className="flex items-center space-x-2">
        <span className="px-4 py-2 bg-blue-600 text-white rounded-lg font-semibold">
          {currentPage}
        </span>
      </div>

      <button
        onClick={handleNext}
        disabled={!hasMore}
        className={`flex items-center px-5 py-2.5 rounded-lg font-medium transition-all ${
          !hasMore
            ? 'bg-gray-100 text-gray-400 cursor-not-allowed dark:bg-gray-800 dark:text-gray-600'
            : 'bg-white text-gray-700 hover:bg-gray-50 shadow-md hover:shadow-lg dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700'
        }`}
      >
        Sonraki
        <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  );
};

export const LoadMoreButton = ({ onClick, loading }) => {
  return (
    <div className="flex justify-center mt-10 mb-6">
      <button
        onClick={onClick}
        disabled={loading}
        className="flex items-center px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {loading ? (
          <>
            <svg className="animate-spin w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Yükleniyor...
          </>
        ) : (
          <>
            Daha Fazla Yükle
            <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </>
        )}
      </button>
    </div>
  );
};

export default NewsPagination;
